import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { Route, Routes, useLocation, useMatch } from 'react-router-dom';

import PortfolioConfirmationStep from './components/PortfolioConfirmationStep';
import PortfolioCustomizationStep from './components/PortfolioCustomizationStep';
import PortfolioSelectionStep from './components/PortfolioSelectionStep';
import PortfolioSuccessStep from './components/PortfolioSuccessStep';

import { WithLayout } from '../RetailApp/components/WithLayout';

export default function App() {
  const match = useMatch('/goals/:goalId/edit_portfolio/externally_advised_plan/*');
  const goalId = useRequiredParam('goalId');
  const { search } = useLocation();
  const shouldReturnToAppSummary = search.includes('return_to_path=%2Fapp');

  return (
    <WithLayout parts={{ sidebar: false }}>
      <FlowContextProvider
        initialValues={{ goalId, shouldReturnToAppSummary }}
        basePath={match!.pathnameBase}
        routePath=""
      >
        <Routes>
          <Route
            data-feature="investing_edit_goal"
            path="/select"
            element={<StepWrapper name="select">{stepProps => <PortfolioSelectionStep {...stepProps} />}</StepWrapper>}
          />
          <Route
            data-feature="investing_edit_goal"
            path="/customize"
            element={
              <StepWrapper name="customize">{stepProps => <PortfolioCustomizationStep {...stepProps} />}</StepWrapper>
            }
          />
          <Route
            data-feature="investing_edit_goal"
            path="/confirm"
            element={
              <StepWrapper name="confirm">{stepProps => <PortfolioConfirmationStep {...stepProps} />}</StepWrapper>
            }
          />
          <Route
            data-feature="investing_edit_goal"
            path="/success"
            element={<StepWrapper name="success">{stepProps => <PortfolioSuccessStep {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </WithLayout>
  );
}
